import { IAutoReleasePayload } from "models/contract/autoRelease";
import { IInquiryDetailPayload } from "models/contract/inquiryDetail";
import { createApiCall2, MethodType, URI } from "../Api";

export const fetchContractInformation = () => {
  return createApiCall2(MethodType.GET, URI.CONTRACT.INFORMATION);
};

export const autoReleaseContract = (payload: IAutoReleasePayload) => {
  return createApiCall2(MethodType.POST, URI.CONTRACT.AUTO_RELEASE, payload);
};

export const downloadPDFContractInformation = () => {
  return createApiCall2(MethodType.GET, URI.CONTRACT.DOWNLOAD_PDF);
};

export const sendInquiryDetail = (payload: IInquiryDetailPayload) => {
  return createApiCall2(MethodType.POST, URI.CONTRACT.INQUIRY_DETAIL, payload);
};
